/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Loop_Wave_TitleInputs */

const en_mk_loop_wave_title = /** @type {(inputs: Mk_Loop_Wave_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wave mode`)
};

const id_mk_loop_wave_title = /** @type {(inputs: Mk_Loop_Wave_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mode Gelombang`)
};

/**
* | output |
* | --- |
* | "Wave mode" |
*
* @param {Mk_Loop_Wave_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_loop_wave_title = /** @type {((inputs?: Mk_Loop_Wave_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Loop_Wave_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_loop_wave_title(inputs)
	return en_mk_loop_wave_title(inputs)
});